/**
* @author zjc[beica1@outook.com]
* @date 2021/9/6 14:27
* @description
*   SymbolList.vue of wetrade.www
*/
<template>
  <!-- <div class="market">
    <div class="tab">
      <p class="tab-item" v-for="tab in tabs"
         :key="tab.type"
         :class="{active: tab.type === curTab}"
         @click="changeTab(tab.type)"
      >
        {{tab.label || tab.labelDefault}}
      </p>
    </div>
    <div class="tab-con">
      <div style="display: flex; flex-wrap: wrap;">
        <div class="product-list" v-for="item in products" :key="item.code">
          <div class="product-info">
            <p class="code">{{item.code}}</p>
            <p class="mp-text" :class="isRise(item) ? 'green' : 'red'">
              {{isRise(item) ? '+' : ''}}{{item.realTimeMicroQuotationBean.mp}}
            </p>
          </div>
          <TheChart :code="item.code" :isRise="isRise(item)" />
        </div>
      </div>
    </div>
  </div> -->

  <div class="chart-wrap">
    <div class="tab-wrap">
      <p class="t-item" v-for="tab in tabs"
         :key="tab.type"
         :class="{active: tab.type === curTab}"
         @click="changeTab(tab.type)"
      >
        {{tab.label || tab.labelDefault}}
      </p>
    </div>

    <div class="sy-table">
      <div class="loading" v-if="products.length===0">
        <div class="spinner">
          <div class="bounce1"></div>
          <div class="bounce2"></div>
          <div class="bounce3"></div>
        </div>
      </div>
      <div class="sy-line" v-else v-for="item in products" :key="item.code">
        <img class="sy-icon" :src="item.icon" alt="">
        <div class="code-name">
          <h5>{{ item.code }}</h5>
          <p>{{ item.code }}</p>
        </div>
        <TheChart :code="item.code" :isRise="isRise(item)" />

        <div class="val-wrap">
          <p class="mp-text" :class="isRise(item) ? 'green' : 'red'">
            {{item.realTimeMicroQuotationBean.sell}}
          </p>
          <p v-if="!home" class="mp-text" :class="isRise(item) ? 'green' : 'red'">
            {{item.realTimeMicroQuotationBean.buy}}
          </p>
          <p v-if="!home" class="mp-text" :class="isRise(item) ? 'green' : 'red'">
            {{isRise(item) ? '+' : '-'}}{{item.realTimeMicroQuotationBean.margin}}
          </p>
          <p class="mp-text" :class="isRise(item) ? 'green' : 'red'">
            {{isRise(item) ? '+' : '-'}}{{item.realTimeMicroQuotationBean.mp}}
          </p>
        </div>

        <div class="c-btn trade-button" :data-code="item.code" @click="webPlatform">{{ $t('home_34') }}</div>
      </div>
    </div>

    <div class="t-btm" @click="seeMore" v-if="!hideSeeMore">
      <p>{{$t('home_35')}}</p>
      <img src="../assets/images/a_right.png" alt="">
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import config from '../config'
import { jsonp } from '../utils/request'
import TheChart from './home/TheChart'

export default {
  name: 'SymbolList',
  components: { TheChart },
  props: {
    home: {
      type: Boolean,
      default: false,
    },
    hideSeeMore: {
      type: Boolean,
      default: false,
    },
  },
  data () {
    return {
      tabs: [
        {
          label: this.$t('home_28'),
          type: 0,
          labelDefault: 'Crypto',
        }, {
          label: this.$t('home_29'),
          type: 2,
          labelDefault: 'Forex',
        }, {
          label: this.$t('home_30'),
          type: 1,
          labelDefault: 'Commodities',
        }, {
          label: this.$t('home_32'),
          type: 5,
          labelDefault: 'Stocks',
        }, {
          label: this.$t('home_33'),
          type: 4,
          labelDefault: 'Indices',
        },
      ],
      curTab: 0,
      products: [],
    }
  },
  mounted () {
    this.changeTab(this.curTab)
  },
  methods: {
    webPlatform(){
      window.open('https://webtrader.wetrade.one/')
    },
    changeTab (index) {
      this.products = []
      this.curTab = index

      if(index === 0){
        jsonp(config.server.api + '/api/contactproduct/watch/list/jsonp', { excode: 'EX' }).then(res => {
          this.products = res.data.slice(0,6)
        }).catch(err => {
          // console.log(err, 'err')
        })
      } else {
        jsonp(config.server.api + '/api/web/contactproduct/list/jsonp', { isTest: 1, type: index, excode: 'EX' }).then(res => {
          this.products = res.data.slice(0,6)
        }).catch(err => {
          // console.log(err, 'err')
        })
      }
    },
    isRise (item) {
      return Number(item.realTimeMicroQuotationBean.margin) >= 0
    },
    seeMore(){
      this.$emit('seeMore')
    }
  },
}
</script>

<style scoped lang="scss">
.chart-wrap{
  width: 100%;
  background: #FFFFFF;
  border-radius: 12px;
  border: 1px solid #D7DDE1;
  padding-bottom: 30px;
  .tab-wrap{
    display: flex;
    height: 80px;
    align-items: center;
    .t-item{
      margin: 0 30px;
      font-size: 14px;
      font-family: Roboto-Bold, Roboto;
      font-weight: bold;
      color: #181D24;
      line-height: 16px;
      cursor: pointer;
      padding-bottom: 8px;
      border-bottom: 2px solid #fff;
      &.active{
        border-bottom: 2px solid #326BFE;
      }
    }

  }

  .sy-table{
    padding: 0 30px;
    .sy-line{
      height: 60px;
      display: flex;
      align-items: center;
      border-bottom: 1px solid #ECEFF4;
      .sy-icon{
        height: 32px;
        width: 32px;
        margin-right: 20px;
      }
      .code-name{
        width: 148px;
        h5{
          font-size: 14px;
          font-weight: 400;
          color: #181D24;
          line-height: 16px;
        }
        p{
          height: 16px;
          font-size: 12px;
          font-weight: 400;
          color: #5C6E7B;
          line-height: 16px;
        }
      }
      .val-wrap{
        padding: 0 30px;
        display: flex;
        align-items: center;
        justify-content: space-between;
      }

      .c-btn{
        padding: 0 16px;
        color: #fff;
        font-size: 14px;
        font-weight: 500;
        height: 34px;
        line-height: 34px;
        background: #326BFE;
        border-radius: 6px;
        cursor: pointer;
      }
    }
  }

  .t-btm{
    display: flex;
    align-items: center;
    padding-left: 30px;
    margin-top: 14px;
    p{
      height: 16px;
      font-size: 14px;
      font-weight: 400;
      color: #A1AEB6;
      line-height: 16px;
      margin-right: 8px;
      cursor: pointer;
    }
    img{
      height: 16px;
      width: 16px;
      cursor: pointer;
    }
  }
}


.spinner {
  margin: 100px auto 100px;
  width: 70px;
  text-align: center;
}
 
.spinner > div {
  width: 12px;
  height: 12px;
  background-color: #5C6E7B;
 
  border-radius: 100%;
  display: inline-block;
  -webkit-animation: sk-bouncedelay 1.4s infinite ease-in-out both;
  animation: sk-bouncedelay 1.4s infinite ease-in-out both;
}
 
.spinner .bounce1 {
  -webkit-animation-delay: -0.32s;
  animation-delay: -0.32s;
}
 
.spinner .bounce2 {
  -webkit-animation-delay: -0.16s;
  animation-delay: -0.16s;
}
 
@-webkit-keyframes sk-bouncedelay {
  0%, 80%, 100% { -webkit-transform: scale(0) }
  40% { -webkit-transform: scale(1.0) }
}
 
@keyframes sk-bouncedelay {
  0%, 80%, 100% { 
    -webkit-transform: scale(0);
    transform: scale(0);
  } 40% { 
    -webkit-transform: scale(1.0);
    transform: scale(1.0);
  }
}



.market {
  background: #ECEFF4;
  border-radius: 10px;
  display: flex;
  padding: 0 0 20px 20px;
}

.tab {
  min-width: 160px;
  max-width: 160px;
  text-align: center;
}

.tab-item {
  height: 58px;
  line-height: 58px;
  font-size: 14px;
  color: #0F172F;
  cursor: pointer;

  &.active {
    background: #FFFFFF;
    font-family: Roboto-Bold;
    border-radius: 10px 0 0 10px;
    box-shadow: 8px 8px 16px 0px rgba(11, 30, 78, 0.1);
  }
}

.tab-con {
  flex: 1;
  background: #FFFFFF;
  box-shadow: 16px 8px 16px 0px rgba(11, 30, 78, 0.1);
  border-radius: 0 10px 10px 0;
  padding: 10px 30px;
  margin-right: -20px;
}

.product-list {
  display: flex;
  align-items: center;
  min-width: 50%;
  max-width: 50%;
  margin: 20px 0;
}

.product-info {
  min-width: 80px;
  max-width: 80px;
  margin-right: 30px;
  font-size: 16px;
  line-height: 20px;
}

.code {
  margin-bottom: 10px;
  font-family: Roboto-Bold;
}

.mp-text {
  margin: 0 30px;
  font-size: 14px;
  width: 80px;
  &.green {
    color: #00C756;
  }

  &.red {
    color: #F24A3A;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/SymbolList.vue